// The program's routes, as the page's address names them: a page of the
// site (/what), an app (/agent), or the docs (/docs, /docs/install), each
// at the site's root, which is wherever the page is served from. The
// program shows each (cmd/hotty-demo-wasm, internal/site), and its
// address follows what it shows.

const ROUTES = ["what", "architecture", "install", "apps", "shell", "agent", "top", "metrics", "review", "feed", "storybook"];

/** The docs' route and its pages': docs, docs/install. */
export function isDocs(route: string): boolean {
  return route === "docs" || route.startsWith("docs/");
}

/** The route a path names, and the site's root before it: "" at the
 * root, the tour's. The docs' pages are routes a directory deep or more,
 * their trailing slash not part of them. */
export function split(path: string): { root: string; route: string } {
  const docs = path.search(/\/docs(\/|$)/);
  if (docs >= 0) return { root: path.slice(0, docs + 1), route: path.slice(docs + 1).replace(/\/+$/, "") };
  const last = path.slice(path.lastIndexOf("/") + 1);
  if (ROUTES.includes(last)) return { root: path.slice(0, -last.length), route: last };
  return { root: path.replace(/[^/]*$/, ""), route: "" };
}

/** The route a path names. */
export function routeOf(path: string): string {
  return split(path).route;
}

/** The site's root, as the page's address was when it loaded: where the
 * program's files are (/hotty-demo.wasm, /apps/agent.wasm). */
export const root = split(location.pathname).root;
